<template>
     <div class="pa-5">
        <v-card>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" :to="{name : 'NewVotingSubscriptionView'}">New Subscription</v-btn>
            </v-card-actions>
            <v-data-table
                :headers="headers"
                :items="subscriptions"
                class="elevation-1"
                >
                <template v-slot:body = {items}>
                    <tbody>
                        <tr
                            v-for="item in items"
                            :key="item.id"
                        >
                            
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card>
     </div>
</template>
<script>
export default {
    name: 'VotingSubscriptionsView',
    data() {
        return {
            subscriptions : [],
            headers : [
                {
                    text : 'Order ID',
                    value : 'order_id',
                    sortable : true
                },
                {
                    text : 'Client',
                    value : 'order_id',
                    sortable : true
                },
                {
                    text : 'Start Date',
                    value : 'start_date',
                    sortable : true
                },
                {
                    text : 'End Date',
                    value : 'end_date',
                    sortable : true
                }
            ]
        };
    },
    methods: {
       
    }
};
</script>